import { Typography } from "@mui/material"

const RedStarRequired = (props) => {
  return (
    <Typography
      {...props}
      sx={{
        color: "#cc6058",
        fontSize: "18px",
        fontWeight: 500,
      }}
    >
      &nbsp;*
    </Typography>
  )
}

export default RedStarRequired;
